import {
  AmplitudeContext,
  AmplitudeEventHelpers,
  AmplitudeEventConstants,
} from '@homebot/shared-util-quartermaster'
import {
  selectCustomerType,
  selectCustomerPhotoUri,
  selectCustomerFirstName,
} from '../../../../store/selectors/customerProfile'
import {
  selectSponsorshipFullName,
  selectSponsorshipPhotoUri,
  selectSponsorshipFirstName,
} from '../../../../store/selectors/sponsorship'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Avatar, Text, Button } from '../../..'
import { IconCommentRight } from '../../../shared/Icon'
import { SponsorBranding } from '../../../shared/SponsorBranding'
import { SlideOnMount, FadeOnMount } from '../../../shared/Animations'

import styles from './RefiRateRequestPanel.module.scss'

const RefiRateRequestPanelInfo = ({ doSubmit, didSubmit }) => {
  const { ampli } = useContext(AmplitudeContext)
  const customerType = useSelector(selectCustomerType)

  const customer = {
    firstName: useSelector(selectCustomerFirstName),
    photoUri: useSelector(selectCustomerPhotoUri),
  }
  const sponsor = {
    firstName: useSelector(selectSponsorshipFirstName),
    fullName: useSelector(selectSponsorshipFullName),
    photoUri: useSelector(selectSponsorshipPhotoUri),
  }

  const handleSubmit = () => {
    ampli?.clientRequestedInfo({
      request_type: AmplitudeEventConstants.REFI,
      customer_type:
        AmplitudeEventHelpers.getAmplitudeCustomerType(customerType),
    })
    doSubmit()
  }

  return (
    <>
      <SlideOnMount>
        <Avatar className={styles.avatar} src={sponsor.photoUri} />
        <Text
          size='xl'
          className={styles.title}
          variant='neutralCool'
          variantCount='900'
        >
          <FormattedMessage
            id='RefiRateRequestPanelInfo.title'
            defaultMessage='Want a custom rate quote from {fullName}?'
            values={{ fullName: sponsor.fullName }}
          />
        </Text>
      </SlideOnMount>
      <SlideOnMount>
        <Text
          variant='neutralCool'
          variantCount='700'
          size='s'
          className={styles.subTitle}
        >
          <FormattedMessage
            id='RefiRateRequestPanelInfo.subTitle'
            defaultMessage='Whether you’re hoping to lower your monthly payment, pull cash out, or consolidate debt, {firstName} can optimize your home finance goals.'
            values={{ firstName: sponsor.firstName }}
          />
        </Text>
      </SlideOnMount>
      <SlideOnMount>
        <div className={styles.voucher}>
          <Avatar className={styles.avatar} src={customer.photoUri} />
          <Text variant='neutralCool' variantCount='700' size='s'>
            <FormattedMessage
              id='RefiRateRequestPanelInfo.voucher'
              defaultMessage='{customerFirstName} trusts {sponsorFirstName} to help answer their clients’ financial questions'
              values={{
                customerFirstName: customer.firstName,
                sponsorFirstName: sponsor.firstName,
              }}
            />
          </Text>
        </div>
      </SlideOnMount>
      <SlideOnMount>
        <SponsorBranding className={styles.branding} />
      </SlideOnMount>
      <FadeOnMount>
        <Button
          className={styles.submitButton}
          onClick={handleSubmit}
          iconStart={IconCommentRight}
          loading={didSubmit}
          primary
        >
          <FormattedMessage
            id='RefiRateRequestPanelInfo.button'
            defaultMessage='Get your rate!'
          />
        </Button>
      </FadeOnMount>
    </>
  )
}

RefiRateRequestPanelInfo.propTypes = {
  doSubmit: PropTypes.func.isRequired,
  didSubmit: PropTypes.bool,
}

export default RefiRateRequestPanelInfo
